<template>
  <PageLayout :page-title="$t('nav.news')" banner-key="news">
    <div class="newsDiv news-page">
      <div class="news-page__inner wrap">
        <header class="news-page__head">
          <h1 class="news-page__title">{{ pageTitle }}</h1>
        </header>

        <nav class="news-category-nav" aria-label="news">
          <div class="news-category-nav__cats">
            <router-link
              to="/news/"
              class="news-category-nav__cat"
              :class="{ 'is-active': !newsSlug }"
            >
              {{ $t('common.allNews') }}
            </router-link>
            <router-link
              v-for="n in newsNav"
              :key="n.slug"
              :to="'/news/' + n.slug + '/'"
              class="news-category-nav__cat"
              :class="{ 'is-active': newsSlug === n.slug }"
            >
              {{ navItemLabel(n) }}
            </router-link>
          </div>
        </nav>

        <div class="news-page__body" v-if="newsList.length">
          <div class="news-tiles">
            <router-link
              v-for="item in newsList"
              :key="item.id"
              :to="'/news/' + item.category + '/' + item.id + '.html'"
              class="news-tile"
            >
              <span class="news-tile__media">
                <img v-if="item.image" :src="$media(item.image)" :alt="item.title">
              </span>
              <span class="news-tile__name">{{ item.title }}</span>
              <span class="news-tile__date">{{ formatDate(item.date) }}</span>
            </router-link>
          </div>
          <PagePagination
            :page="pageNum"
            :total="total"
            :page-size="pageSize"
            @change="onPageChange"
          />
        </div>
        <p v-else class="news-page__empty">{{ $t('common.noContent') }}</p>
      </div>
    </div>
  </PageLayout>
</template>

<script>
import PageLayout from '@/components/hirays/PageLayout.vue'
import { listNews } from '@/utils/http'
import { unwrapRows, mapNewsItem, getNewsTypeBySlug } from '@/utils/content'
import { fetchSiteNav } from '@/utils/siteNav'
import { NEWS_NAV } from '@/constants/hiraysData'
import PagePagination from '@/components/hirays/PagePagination.vue'
import { DEFAULT_PAGE_SIZE, unwrapTotal, scrollToListTop } from '@/utils/pagination'

export default {
  components: { PageLayout, PagePagination },
  props: { newsSlug: { type: String, default: '' } },
  data() {
    return {
      newsList: [],
      newsNav: NEWS_NAV.map(n => ({ slug: n.slug, name: n.title, newsType: n.type })),
      pageNum: 1,
      pageSize: DEFAULT_PAGE_SIZE,
      total: 0
    }
  },
  computed: {
    pageTitle() {
      if (!this.newsSlug) return this.$t('nav.news')
      const item = this.newsNav.find(n => n.slug === this.newsSlug)
      return item ? this.navItemLabel(item) : this.$t('nav.news')
    },
    newsType() {
      if (!this.newsSlug) return null
      const fromNav = this.newsNav.find(n => n.slug === this.newsSlug)
      if (fromNav && fromNav.newsType != null) return fromNav.newsType
      return getNewsTypeBySlug(this.newsSlug)
    }
  },
  watch: {
    newsSlug() {
      this.pageNum = 1
      this.load()
    }
  },
  created() {
    this.loadNav()
    this.load()
  },
  methods: {
    reloadCmsData() {
      this.loadNav()
      this.load()
    },
    navItemLabel(item) {
      if (item && item.slug && this.$te('newsNav.' + item.slug)) {
        return this.$navLabel('newsNav', item.slug, item.name)
      }
      return this.$cleanBrand(item.name || item.slug)
    },
    async loadNav() {
      try {
        const nav = await fetchSiteNav(false, this.$i18n.locale)
        if (nav && nav.newsNav && nav.newsNav.length) this.newsNav = nav.newsNav
      } catch (e) { /* fallback */ }
    },
    async load() {
      const params = { status: 1, pageNum: this.pageNum, pageSize: this.pageSize }
      if (this.newsType != null) params.type = this.newsType
      try {
        const res = await listNews(params, this.$i18n.locale)
        this.newsList = unwrapRows(res).map(mapNewsItem)
        this.total = unwrapTotal(res) || this.newsList.length
      } catch (e) {
        this.newsList = []
        this.total = 0
      }
    },
    onPageChange(page) {
      this.pageNum = page
      this.load()
      scrollToListTop(this.$el.querySelector('.news-page__body') || this.$el)
    },
    formatDate(date) {
      if (!date) return ''
      return String(date).replace(/-/g, '.').substring(0, 10)
    }
  }
}
</script>
